import React from "react";
import styles from "../../../../styles/AdminConsole.module.css";
import Modal from "../../shared/components/Modal";

/**
 * LogContactModal
 *
 * Props:
 *   lead      object — lead being logged (used for title)
 *   date      string (YYYY-MM-DD)
 *   note      string
 *   saving    bool
 *   onDateChange  (val) => void
 *   onNoteChange  (val) => void
 *   onSave    () => void
 *   onClose   () => void
 */
const LogContactModal = React.memo(function LogContactModal({
  lead,
  date,
  note,
  saving,
  onDateChange,
  onNoteChange,
  onSave,
  onClose,
}) {
  return (
    <Modal title={`Log Contact — ${lead.buyerName}`} onClose={onClose}>
      <div className={styles.formInner}>
        <div>
          <span
            className={styles.toggleLabelText}
            style={{ display: "block", marginBottom: 4, fontSize: 10 }}
          >
            Date *
          </span>
          <input
            className={styles.input}
            type="date"
            value={date}
            onChange={(e) => onDateChange(e.target.value)}
          />
        </div>
        <input
          className={styles.input}
          placeholder="Note (optional) — Call / Email / Visit…"
          value={note}
          onChange={(e) => onNoteChange(e.target.value)}
        />
        <button
          className={`${styles.btn} ${styles.btnPrimary}`}
          disabled={saving}
          onClick={onSave}
        >
          {saving ? "Saving…" : "Log Contact"}
        </button>
      </div>
    </Modal>
  );
});

export default LogContactModal;
